import * as TabsPrimitive from "@radix-ui/react-tabs";
import * as React from "react";

import { generateValidClassNameHandler } from "@/lib/utils";

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({
    className,
    ...props
}, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={generateValidClassNameHandler(
            "inline-flex h-fit items-center border-b border-gray-300 w-full bg-transparent text-gray-500 overflow-auto",
            className,
        )}
        {...props}
    />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({
    className,
    ...props
}, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={generateValidClassNameHandler(
            "inline-flex items-center justify-center whitespace-nowrap text-gray-400 rounded-none px-3 py-1.5 text-xs md:text-sm transition-all duration-300 disabled:cursor-not-allowed disabled:opacity-50 bg-transparent shadow-none data-[state=active]:text-primary data-[state=active]:font-medium data-[state=active]:border-b-primary data-[state=active]:border-b-2",
            className,
        )}
        {...props}
    />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({
    className,
    ...props
}, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        className={generateValidClassNameHandler(
            "mt-2",
            className,
        )}
        {...props}
    />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
};
